export default __webpack_public_path__ + "static/media/playstore.658bbf74.svg";